import React, {useRef, useState} from "react";
import Overlay from "react-bootstrap/Overlay";
import RBTooltip from "react-bootstrap/Tooltip";

export function Tooltip(props) {
  const {placement = "top", message, element, displayOption, ...rest} = props;
  const targetRef = useRef(null);
  const [show, setShow] = useState(false);
  const Element = element ? element : "div";
  const {
    onMouseEnter,
    onMouseLeave,
    onFocus,
    onBlur,
    disabled,
    ...elementProps
  } = rest;

  return (
    <>
      <Element
        {...elementProps}
        ref={targetRef}
        onMouseEnter={(e) => {
          onMouseEnter?.(e);
          if (!disabled) {
            setShow(true);
          }
        }}
        onMouseLeave={(e) => {
          onMouseLeave?.(e);
          setShow(false);
        }}
        onFocus={(e) => {
          onFocus?.(e);
          if (!disabled) {
            setShow(true);
          }
        }}
        onBlur={(e) => {
          onBlur?.(e);
          setShow(false);
        }}
      >
        {props.children}
      </Element>
      <Overlay target={targetRef.current} show={show && !!message} placement={placement}>
        {(overlayProps) => (
          <RBTooltip {...overlayProps} className={displayOption ? displayOption : ""}>
            {message}
          </RBTooltip>
        )}
      </Overlay>
    </>
  );
}


// import React from "react";
// import {getElementPosition, getViewportSize} from "../../../utils/browser";
// import {findDOMNode} from "react-dom";
// import {Consumer} from "./manager";

// class TooltipHandler extends React.Component {
//   state = {
//     render: false,
//     size: {}
//   };
//   componentDidMount = () => {
//     return this.setState({
//       render: true,
//       size: this.ref.getBoundingClientRect()
//     });
//   }
//   render() {
//     let style = {
//       willChange: "transform",
//       position: "absolute",
//       top: 0,
//       left: 0,
//     };

//     const vp = getViewportSize();
//     const {size} = this.state;
//     let left = this.props.position.left, top = this.props.position.top;
//     let arrowLeft = 0, arrowTop = 0;
//     if (!this.state.render) {
//       style.visibility = "hidden";
//     } else {
//       arrowLeft = (size.width / 2) - 6;
//       switch (this.props.placement) {
//         case "top":
//           left += (this.props.position.width / 2);
//           left -= (size.width / 2);
//           top -= size.height;
//           if (vp.w < (left + size.width)) {
//             const modifier = vp.w - (left + size.width);
//             left += modifier;
//             arrowLeft -= (modifier / 2);
//           }
//           break;
//         case "bottom": // have not tested this
//           left += (this.props.position.width / 2);
//           left -= (size.width / 2);
//           top += this.props.position.height;
//           if (vp.w < (left + size.width)) {
//             const modifier = vp.w - (left + size.width);
//             left += modifier;
//             arrowLeft -= (modifier / 2);
//           }
//           break;

//         case "right":
//           left += this.props.position.width;
//           top += size.height / 4;
//           arrowLeft = 0;
//           arrowTop += size.height / 4;
//           break;
//       }
//       style.top = `${top}px`;
//       style.left = `${left}px`;
//       style.zIndex = 99999;
//       //  = `translate(${left}px, ${top}px, 0px)`;
//     }

//     return (<div ref={(r) => {this.ref = r;}} className={`tooltip fade bs-tooltip-${this.props.placement} show`} role="tooltip" style={style}>
//       <div className="arrow" style={{left: arrowLeft, top: arrowTop}}/>
//       <div className="tooltip-inner">
//         {this.props.message}
//       </div>
//     </div>);
//   }
// }
// TooltipHandler.removeOnScroll = true;

// class TooltipBase extends React.Component {
//   state = {
//     tooltipId: undefined,
//   }
//   componentWillUnmount = async() => {
//     if (this.state.tooltipId) {
//       await this.props.bsHelper.removeElement(this.state.tooltipId);
//     }
//   }
//   handleMouseOver = async() => {
//     const node = findDOMNode(this.targetRef);
//     const position = getElementPosition(node);
//     return this.setState({
//       tooltipId: await this.props.bsHelper.showElement(TooltipHandler, {
//         placement: this.props.placement,
//         message: this.props.message,
//         position,
//       }),
//     });
//   }
//   handleMouseOut = async() => {
//     await this.props.bsHelper.removeElement(this.state.tooltipId);
//     return this.setState({
//       toolTipId: null,
//     });
//   }

//   render() {
//     const {message, placement, element, bsHelper, disabled, ...rest} = this.props;
//     const Element = element ? element : "div";
//     return (<Element {...rest} ref={(ref) => {this.targetRef = ref;}} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut} disabled={disabled}>
//       {this.props.children}
//     </Element>);
//   }
// }


// export function withTooltip(Component) {
//   // ...and returns another component...
//   return function ThemedComponent(props) {
//     // ... and renders the wrapped component with the context theme!
//     // Notice that we pass through any additional props as well
//     return (
//       <Consumer>
//         {bsHelper => <Component {...props} bsHelper={bsHelper} />}
//       </Consumer>
//     );
//   };
// }

// export const Tooltip = withTooltip(TooltipBase);

